import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    get: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite`,
        cache: true
    },
    getTitle: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite/title`
    },
    saveTitle: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/title`
    },
    getAppearance: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite/appearance`
    },
    saveAppearance: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/appearance`
    },
    getUtilityLink: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite/homeLink`
    },
    saveUtilityLink: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/homeLink`
    },
    getAnalytics: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite/analytics`
    },
    saveAnalytics: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/analytics`
    },
    getHomePageSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite/homePageSettings`
    },
    saveHomePageSettings: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/homePageSettings`
    },
    getImageAndAssets: {
        method: 'GET',
        isArray: true,
        url: `${BASE_PATH_API}/publicSite/assets`
    },
    deleteImageAndAsset: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/publicSite/assets/:id`
    },
    addImageAndAsset: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/assets`
    },
    getCustomPages: {
        method: 'GET',
        isArray: true,
        url: `${BASE_PATH_API}/publicSite/customPages`
    },
    saveCustomPages: {
        method: 'POST',
        isArray: true,
        url: `${BASE_PATH_API}/publicSite/customPages`
    },
    getCustomPageContent: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite/customPages/:pageTypeId`
    },
    saveCustomPageContent: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/customPages/:pageTypeId`
    },
    getEnablePublicSite: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite/enablePublicSite`
    },
    setEnablePublicSite: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/enablePublicSite`
    },
    getResponsivePublicSiteStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite/responsivePublicSiteStatus`
    },
    setResponsivePublicSiteStatus: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/responsivePublicSiteStatus`
    },
    getGeneralSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite/generalSettings`
    },
    saveGeneralSettings: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/generalSettings`
    },
    getThemesForAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite/themes`
    },
    saveThemeSelection: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/selectTheme`
    },
    createCustomTheme: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/createTheme`
    },
    updateCustomTheme: {
        method: 'PUT',
        url: `${BASE_PATH_API}/publicSite/updateTheme`
    },
    getHomePageLayoutOptions: {
        method: 'GET',
        url: `${BASE_PATH_API}/publicSite/homePageLayoutOptions`
    },
    setHomePageLayoutOptions: {
        method: 'POST',
        url: `${BASE_PATH_API}/publicSite/homePageLayoutOptions`
    }
};

export function PublicsiteApi() {
    return createActions(actions);
}
